module.exports = __webpack_public_path__ + "static/media/preparing.014ea0de.svg";